// extracted by mini-css-extract-plugin
export default {"root":"PageHeader_root__kH5rs","arrow":"PageHeader_arrow__x3T+m"};